import axios from "axios";
import { getAccessToken } from "utils/helper";

const baseURL = process.env.REACT_APP_API_URL;

export const axiosInstance = axios.create({
  baseURL,
});
// ("http://172.17.10.16:20003");

axiosInstance.interceptors.request.use(
  (config) => {
    if (getAccessToken()) {
      config.headers.Authorization = `Bearer ${getAccessToken()}`;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
